import { DeviceModelTypes } from "@/commons/enums/model-type";
import { CableT } from "@/passets/devicebase-engine/models/CableT";
import { Command, ModelBase, TnEngineExtraContext } from "pytha";

export class MonixEraseCommand extends Command {

    entities: ModelBase[];
    updateArr: ModelBase[];
    updateArrClone: ModelBase[];
    isDelete: Number;
    extraContext: TnEngineExtraContext;

    // roadNetworkList: any[] = []
    // roadUuidList: string[] = []

    constructor(entities: ModelBase[]) {
        super();

        this.extraContext = TnEngineExtraContext.getInstance();
        this.editor = this.extraContext.getCurrentViewEditor();
        this.entities = entities;
        const updateDict = {}; // 相关待更新的图元
        const deleteDict = {}; // 相关待删除的图元
        const entityUuidSet = new Set();

        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];
            entityUuidSet.add(entity.uuid);
            deleteDict[entity.uuid] = entity;
            if (DeviceModelTypes.some(t => t === entity.type)) {
                // 是特殊设备类型，需考虑线缆的删除问题
                let needDeleteCables: CableT[] = this.editor.getEntities().filter(item => item.type === 'CableT'
                    && item?.extraData?.firstDeviceUuid
                    && item?.extraData?.secondDeviceUuid
                    && entity.uuid === item?.extraData?.firstDeviceUuid || entity.uuid === item?.extraData?.secondDeviceUuid) || [];
                needDeleteCables?.forEach(cable => {
                    deleteDict[cable.uuid] = cable;
                })
            }
        }

        // 遍历deleteDict，将在entities中没有的图元放入entities
        for (let key in deleteDict) {
            if (!entityUuidSet.has(key)) {
                this.entities.push(deleteDict[key]);
            }
        }

        this.updateArr = [];
        this.updateArrClone = [];
        // 遍历updateDict，备份原始图元数据
        for (let key in updateDict) {
            const entityClone = this.editor.entityDict[key].clone();
            entityClone.uuid = key;
            this.updateArr.push(updateDict[key]);
            this.updateArrClone.push(entityClone);
        }
    }

    execute = () => {
        if (this.updateArr?.length > 0) {
            this.editor.addObjects(this.updateArr);
            this.extraContext.apiContext.createPrimitiveMulti(this.updateArr.map((entity: ModelBase) => {
                if (entity.toJson) {
                    return entity.toJson();
                }
                return null;
            }));
        }

        this.editor.removeObjects(this.entities);

        let filterList = this.entities.filter(entity => entity.positionUpdateCallBack);
        this.editor.listeners.signals.onEntitiesUpdatePosition.dispatch(filterList, true);
        this.extraContext.apiContext.deletePrimitivesInGraphic(this.entities.map(entity => entity.uuid));
    }

    undo(): void {
        if (this.updateArrClone) {
            let par = this.updateArrClone?.filter(item => item.type !== 'RoamPointT');
            // this.editor.addObjects(this.updateArrClone);
            this.editor.addObjects(par);
            // this.extraContext.apiContext.createPrimitiveMulti(this.updateArrClone.map((entity: ModelBase) => {
            this.extraContext.apiContext.createPrimitiveMulti(par.map((entity: ModelBase) => {
                if (entity.toJson) {
                    return entity.toJson();
                }
                return null;
            }));
        }

        let par = this.entities?.filter(item => item.type !== 'RoamPointT');
        // this.editor.addObjects(this.entities);
        this.editor.addObjects(par);
        // let filterList = this.entities.filter(entity => entity.positionUpdateCallBack);
        let filterList = par.filter(entity => entity.positionUpdateCallBack);
        this.editor.listeners.signals.onEntitiesUpdatePosition.dispatch(filterList);
        // this.extraContext.apiContext.createPrimitiveMulti(this.entities.map((entity: ModelBase) => {
        this.extraContext.apiContext.createPrimitiveMulti(par.map((entity: ModelBase) => {
            if (entity.toJson) {
                return entity.toJson();
            }
            return null
        }));
    }
}